export async function encrypt(data, base64Key) {
  const key = await importKey(base64Key); // Convert Base64 key to CryptoKey
  const iv = window.crypto.getRandomValues(new Uint8Array(12)); // Random IV

  const encodedData = new TextEncoder().encode(data);
  const encryptedData = await window.crypto.subtle.encrypt(
    { name: "AES-GCM", iv: iv },
    key,
    encodedData
  );

  return {
    encrypted: arrayBufferToBase64(encryptedData),
    iv: arrayBufferToBase64(iv.buffer)
  };
}

export async function decrypt(encryptedObject, base64Key) {
  const { encrypted, iv } = encryptedObject;
  const key = await importKey(base64Key); // Convert Base64 key to CryptoKey

  const decryptedData = await window.crypto.subtle.decrypt(
    { name: "AES-GCM", iv: base64ToArrayBuffer(iv) },
    key,
    base64ToArrayBuffer(encrypted)
  );

  return new TextDecoder().decode(decryptedData);
}

// ✅ Import a Base64-encoded 32-byte AES key
async function importKey(base64Key) {
  const rawKey = base64ToArrayBuffer(base64Key);
  return await window.crypto.subtle.importKey(
    "raw",
    rawKey,
    { name: "AES-GCM", length: 256 },
    false,
    ["encrypt", "decrypt"]
  );
}

// Browser-compatible base64 encoding/decoding functions
function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

function base64ToArrayBuffer(base64: string): ArrayBuffer {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
}
